import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/AthmikaU_Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
// import { Document, Page, pdfjs } from "react-pdf";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";

// Set pdf worker
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />

        {/* <Row className="resume">
          <div className="d-flex justify-content-center">
            <Document file={pdf}>
              <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
            </Document>
          </div>
        </Row> */}

        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            marginTop: "250px",
            marginBottom: "250px"
          }}
        >
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{
              maxWidth: "250px",
              padding: "15px 30px", 
              fontSize: "1.2rem"   
            }}
          >
            <AiOutlineDownload />
            &nbsp;View CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;  